import { render } from "./ProjectAssignmentTypes.vue?vue&type=template&id=367791c2"
import script from "./ProjectAssignmentTypes.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__